import React, { useContext, useState, useEffect } from 'react';
import copy from 'copy-to-clipboard';
import UsuarioContext from '../../../context/usuario.context';
import FirebaseContext from '../../../context/firebase.context';
import './vendas.scss';
import { notify } from '../../../functions/notifications';
import { ConvertStringToDate, DataAtual, InverterDataAtualUS } from '../../../functions/helper';
import { NotificarCompraSegura } from '../../../services/apiWhats';

function ModalVendas() {
  const { usuario, usuario: { uid } } = useContext(UsuarioContext);
  const { expectadores } = useContext(FirebaseContext);
  const [listVendas, setListVenda] = useState([]);
  const [filtro, setFiltro] = useState({});

  useEffect(() => {
    if (usuario.uid) {
      const { vendas } = usuario;
      setListVenda(vendas);
    }
  }, [usuario.uid]);

  const openUrl = (url) => {
    window.open(url, '_blank');
  };

  const cpfMask = (value) => value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');

  const cnpjMask = (value) => {
    const x = value
      .replace(/\D/g, '')
      .match(/(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/);
    return !x[2]
      ? x[1]
      : `${x[1]}.${x[2]}.${x[3]}/${x[4]}${x[5] ? `-${x[5]}` : ''}`;
  };

  const setInfo = ({ target }) => {
    const { name, value } = target;
    let newValue = value;
    if (value.length <= 14 && name === 'cpfcnpj') {
      newValue = cpfMask(value);
    } else if (value.length > 14 && name === 'cpfcnpj') {
      newValue = cnpjMask(value);
    }
    setFiltro((prevState) => ({
      ...prevState, [name]: newValue,
    }));
  };

  function filterResults() {
    const { vendas } = usuario;
    let dataInicialFiltro = filtro?.dataInicial || '01/01/1900';
    dataInicialFiltro = ConvertStringToDate(dataInicialFiltro);

    let dataFinalFiltro = filtro?.dataFinal || DataAtual();
    dataFinalFiltro = ConvertStringToDate(dataFinalFiltro);
    const cpfCnpjFiltro = filtro.cpfcnpj || 'todos';

    if (cpfCnpjFiltro !== 'todos') {
      const filterVendas = vendas.filter((value) => {
        const [p1, p2] = Object.keys(value);
        const key = p1 !== 'vendedor' ? p1 : p2;

        if (
          (value[key].cpfcnpj === cpfCnpjFiltro)
           && (ConvertStringToDate(value[key].dataCompra) >= dataInicialFiltro)
          && (ConvertStringToDate(value[key].dataCompra) <= dataFinalFiltro)
        ) {
          return value;
        }
        return null;
      });
      setListVenda(filterVendas);
    } else {
      const filterVendas = vendas.filter((value) => {
        const [p1, p2] = Object.keys(value);
        const key = p1 !== 'vendedor' ? p1 : p2;

        if (
          (ConvertStringToDate(value[key].dataCompra) >= dataInicialFiltro)
          && (ConvertStringToDate(value[key].dataCompra) <= dataFinalFiltro)
        ) {
          return value;
        }
        return null;
      });
      setListVenda(filterVendas);
    }
  }

  return (
    <div id="modal-vendas-exibir">
      <div className="header-filtros-venda">
        <label id="label-dataInicial" className="dataInicial">
          <span>
            Data Inicial
          </span>
          <input
            type="date"
            id="dataInicial"
            name="dataInicial"
            onChange={(e) => {
              setFiltro((prevState) => ({
                ...prevState,
                dataInicial: InverterDataAtualUS(e.target.value),
              }));
            }}
          />
        </label>
        <label id="label-dataFinal" className="dataFinal">
          <span>
            Data Final
          </span>
          <input
            type="date"
            id="dataFinal"
            name="dataFinal"
            onChange={(e) => {
              setFiltro((prevState) => ({
                ...prevState,
                dataFinal: InverterDataAtualUS(e.target.value),
              }));
            }}
          />
        </label>
        <label id="label-cpfcnpj" className="cpfcnpj">
          <span>
            CPF/CNPJ
          </span>
          <input
            onChange={setInfo}
            value={filtro?.cpfcnpj}
            type="text"
            required
            id="cpfcnpj"
            name="cpfcnpj"
            placeholder="Informa o cpf ou cnpj"
          />
        </label>
        <button
          onClick={() => filterResults()}
          className="buttons-transparent"
          type="button"
        >
          <i className="fas fa-search">
            <span>
              Filtrar
            </span>
          </i>
        </button>
      </div>
      <div className="body-content-venda">
        <div className="header-vendas">
          <div className="data-venda">
            <span>
              Data
            </span>
          </div>
          <div className="cliente-venda">
            <span>
              Cliente
            </span>
          </div>
          <div className="produto-venda">
            <span>
              Produto
            </span>
          </div>
          <div className="actions-venda">
            <span>
              Actions
            </span>
          </div>
        </div>
        <div className="content-vendas">
          {
            listVendas.map((venda) => {
              const [p1, p2] = Object.keys(venda);
              const key = p1 !== 'vendedor' ? p1 : p2;
              const {
                dataCompra, empreendimento, produtoAplicado, telefone,
              } = venda[key];
              const linkOpen = `https://agsafe.netlify.app/authentication/${key}/key=${uid}`;
              return (
                <div className="venda">
                  <div className="data-venda">
                    <span>
                      {dataCompra}
                    </span>
                  </div>
                  <div className="cliente-venda">
                    <span>
                      {empreendimento}
                    </span>
                  </div>
                  <div className="produto-venda">
                    <span>
                      {produtoAplicado}
                    </span>
                  </div>
                  <div className="actions-venda">
                    <button
                      aria-label="Visualizar"
                      className="buttons-transparent"
                      type="button"
                      onClick={() => openUrl(linkOpen)}
                    >
                      <i className="fas fa-qrcode" />
                    </button>
                    <button
                      aria-label="Copiar Link"
                      className="buttons-transparent"
                      type="button"
                      onClick={() => {
                        notify('success', 'Link copiado');
                        copy(linkOpen);
                      }}
                    >
                      <i className="far fa-copy" />
                    </button>
                    <button
                      aria-label="Enviar WhatsApp"
                      className="buttons-transparent"
                      type="button"
                      onClick={() => {
                        NotificarCompraSegura({
                          celular: telefone, nome: empreendimento, link: linkOpen,
                        });
                        expectadores.forEach(({ nome, celular }) => {
                          NotificarCompraSegura({
                            celular, nome, link: linkOpen,
                          });
                        });
                        notify('success', 'Certificado enviado ao cliente');
                      }}
                    >
                      <i className="far fa-paper-plane" />
                    </button>
                  </div>
                </div>
              );
            })
          }

        </div>
      </div>
    </div>
  );
}

export default ModalVendas;
